import type { LocationMapProps } from "./location-map.type";

import TreeMap from "@/modules/tree-map";

const LocationMap = ({ location, mapKey, loading }: LocationMapProps) => {
  return (
    <TreeMap
      type="location"
      id={location?.id}
      mapKey={mapKey}
      loading={loading}
      subItemsDepth={1}
    />
  );
};

export default LocationMap;
